import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useUserReviews(userId: string | undefined) {
  return useQuery({
    queryKey: ['reviews', 'user', userId],
    queryFn: () => api.reviews.forUser(userId!),
    enabled: !!userId,
  });
}

export function useTransactionReviews(txId: string | undefined) {
  return useQuery({
    queryKey: ['reviews', 'tx', txId],
    queryFn: () => api.reviews.forTransaction(txId!),
    enabled: !!txId,
  });
}

export function useCreateReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      txId,
      rating,
      body,
    }: {
      txId: string;
      rating: number;
      body: string;
    }) => api.reviews.create(txId, { rating, body }),
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['reviews', 'tx', vars.txId] });
      qc.invalidateQueries({ queryKey: ['bookings', 'one', vars.txId] });
    },
  });
}
